import { runOnReadyState } from '@datadog/browser-core';
import { LifeCycleEventType, } from '@datadog/browser-rum-core';
import { getReplayStats } from '../domain/replayStats';
import { getDeflateWorkerSingleton } from '../domain/segmentCollection/deflateWorkerSingleton';
export function makeRecorderApi(startRecordingImpl, getDeflateWorkerSingletonImpl) {
    if (getDeflateWorkerSingletonImpl === void 0) { getDeflateWorkerSingletonImpl = getDeflateWorkerSingleton; }
    var state = {
        status: 0 /* Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getReplayStats: getReplayStats,
        onRumStart: function (lifeCycle, initConfiguration, configuration, session, parentContexts) {
            lifeCycle.subscribe(LifeCycleEventType.SESSION_EXPIRED, function () {
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    stopStrategy();
                    state = { status: 1 /* IntentToStart */ };
                }
            });
            lifeCycle.subscribe(LifeCycleEventType.SESSION_RENEWED, function () {
                if (state.status === 1 /* IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                if (!session.hasReplayPlan()) {
                    state = { status: 1 /* IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    return;
                }
                state = { status: 2 /* Starting */ };
                runOnReadyState('complete', function () {
                    if (state.status !== 2 /* Starting */) {
                        return;
                    }
                    var worker = getDeflateWorkerSingletonImpl();
                    if (!worker) {
                        state = {
                            status: 0 /* Stopped */,
                        };
                        return;
                    }
                    var stopRecording = startRecordingImpl(lifeCycle, initConfiguration.applicationId, configuration, session, parentContexts, worker).stop;
                    state = {
                        status: 3 /* Started */,
                        stopRecording: stopRecording,
                    };
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* Stopped */) {
                    return;
                }
                if (state.status === 3 /* Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* Stopped */,
                };
            };
            if (state.status === 1 /* IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () { return state.status === 3 /* Started */; },
    };
}
//# sourceMappingURL=recorderApi.js.map